'use client';

import { useEffect } from 'react';

import { Apps, TypesenseEventDocument } from '@/types';
import { addHours } from 'date-fns';

import { useGlobal } from '@/lib/global-store';
import { getIndexName, typesense } from '@/lib/server';

export interface ConfigureBookingsProps {
  tonic?: Apps['tonic'];
  designMyNight?: Apps['designMyNight'];
}

export function ConfigureBookings({ tonic, designMyNight }: ConfigureBookingsProps) {
  const { setBookEvent, setBookTab, setDmnConfig } = useGlobal();

  // set the event and tab when the component mounts so that the navigation book button automatically opens the current event
  useEffect(() => {
    const fetchEvent = async () => {
      const datesStart = Math.round(addHours(new Date(), -3).getTime() / 1000);

      if (tonic?.id) {
        const event = await typesense
          .collections<TypesenseEventDocument>(getIndexName('event'))
          .documents()
          .search({
            q: '',
            query_by: 'tonic.id',
            sort_by: 'dates:asc',
            filter_by: `tonic.id:=${tonic.id} && dates:>=${datesStart}`,
            limit: 250,
          })
          .then((res) => res.hits?.[0]?.document);

        if (event) {
          setBookEvent(event);
          setBookTab('tonic');
        }
      } else {
        setDmnConfig({
          allowedTypes: designMyNight?.id,
          showTypeFirst: true,
        });
        setBookTab('design-my-night');
      }
    };

    fetchEvent();

    return () => {
      setBookEvent(null);
    };
  }, [tonic, designMyNight, setBookEvent, setBookTab, setDmnConfig]);

  return null;
}
